module.exports = __webpack_public_path__ + "img/bank-assert-rules-disabled.34b07d60.svg";